import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const getAuthHeaders = (token) => ({
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "Content-Type": "application/json",
});

// ========================================
// CREATE RAZORPAY ORDER
// ========================================

export const createPaymentOrder = async (
    items,
    addressId,
    token,
    gstInvoice = null
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/create-order`,
        {
            items,
            address_id: addressId,

            ...(gstInvoice
                ? {
                      gst_name: gstInvoice.business_name,
                      gst_number: gstInvoice.gst_number,
                  }
                : {}),
        },
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// VERIFY RAZORPAY PAYMENT
// ========================================

export const verifyPayment = async (
    paymentData,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/verify`,
        paymentData,
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// GET ALL USER ORDERS
// ========================================

export const getMyOrders = async (
    token,
    params = {}
) => {
    const response = await axios.get(
        `${API_BASE_URL}payments/orders`,
        {
            headers: getAuthHeaders(token),
            params,
        }
    );

    return response.data;
};


// ========================================
// GET SINGLE ORDER
// ========================================

export const getOrderDetails = async (
    orderId,
    token
) => {
    const response = await axios.get(
        `${API_BASE_URL}payments/order/${orderId}`,
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// CANCEL PAYMENT
// ========================================

export const cancelPayment = async (
    orderId,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/cancel/${orderId}`,
        {},
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// FAILED PAYMENT
// ========================================

export const failPayment = async (
    orderId,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/failed/${orderId}`,
        {},
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};